class SliderComponentExt extends SliderComponent {
  constructor() {
    super();
    if (this.slider) {
      let thisSliderHtml = this.slider.innerHTML;
      this.autoplay = this.slider.getAttribute("data-autoplay") * 1;
      this.loop = this.slider.dataset.loop && this.slider.dataset.loop === 'true'  ? true: false;
      this.enableSliderLooping = this.autoplay || this.loop ? true : false;
      if(!!this.autoplay ) {
        this.autoPlay()
      }

      if (this.loop) {
        this.sliderTouchX = 0;
        this.slider.addEventListener('touchstart', this.sliderTouchStart.bind(this), false);
        this.slider.addEventListener('touchmove', this.sliderTouchMove.bind(this), false);
        
        this.slider.insertAdjacentHTML('afterbegin', thisSliderHtml);
        this.slider.insertAdjacentHTML('beforeend', thisSliderHtml);

      }
      if( this.enableSliderLooping ) {
        this.prevButton.removeAttribute('disabled');
        this.nextButton.removeAttribute('disabled');
      }
    }
  }

  autoPlay() {
    if (this.inderavlId) {
      clearInterval(this.inderavlId);
    }
    this.inderavlId =  setInterval( () => {
      this.nextButton.click()
    }, this.autoplay * 1000)
  }

  sliderTouchStart(event) {
    this.sliderTouchX = event.touches[0].clientX;
  }

  sliderTouchMove(event) {
    event.preventDefault();
    if (!this.sliderTouchX) return;
    let xDiff = this.sliderTouchX - event.touches[0].clientX;
    if(!!this.autoplay ) {
      this.autoPlay()
    }
    if (xDiff > 0) {
      this.nextButton.click();
    } else {
      this.prevButton.click();
    }
    this.sliderTouchX = null;
  }



  onButtonClick(event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.loop) {
      if(!!this.autoplay ) {
        this.autoPlay()
      }
      if (event.currentTarget.name === 'next') {
        this.slider.insertAdjacentHTML('beforeend', '<li class="s-promo-bar__slider-item">' + this.slider.querySelector('li:first-of-type').innerHTML + '</li>');
        this.slider.querySelector('li:first-of-type').remove();
      } else if (event.currentTarget.name === 'previous') {
        this.slider.insertAdjacentHTML('afterbegin', '<li class="s-promo-bar__slider-item">' + this.slider.querySelector('li:last-of-type').innerHTML + '</li>');
        this.slider.querySelector('li:last-of-type').remove();
      }
    }

    const step = this.loop ? 1 : event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component-ext', SliderComponentExt);